import { all, fork } from 'redux-saga/effects';

import app from './app/app.sagas';
import auth from './auth/auth.sagas';
import users from './users/users.sagas';

export default function*() {
  yield all([...Object.values(app)].map(fork));
  yield all([...Object.values(auth)].map(fork));
  yield all([...Object.values(users)].map(fork));
}



// WEBPACK FOOTER //
// ./src/state/sagasRoot.js